<template>
  <component :is="getComponentName" />
</template>

<script lang="ts" setup>
import MenuDesktop from '@components/Menu/MenuDesktop/MenuDesktop.vue';
import MenuMobileButton from '@components/Menu/MenuMobile/MenuMobileButton.vue';
import useScreenWidth from '@use/useScreenWidth';
import { computed } from 'vue';

const screenWidth = useScreenWidth();

const getComponentName = computed(() => (screenWidth.value < 992 ? MenuMobileButton : MenuDesktop));
</script>
